const titles = ["Mr", "Mrs", "Miss", "Dr", "Prof", "Capt", "Gen"];

export default titles;